import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { parseSearchString } from 'lib/url/searchUrlUtils'
import moment from 'moment'

// Metasearch should preserve structurally valid URL dates even when the shared
// search decoder strips them as stale in the current runtime timezone.
export function getMetasearchDateFilters(
  filters: App.OfferListFilters,
  search: string,
): App.OfferListFilters {
  if (filters.checkIn && filters.checkOut) {
    return filters
  }

  const params = parseSearchString(search)
  const checkIn = params.checkIn
  const checkOut = params.checkOut
  const checkInMoment = moment(checkIn, ISO_DATE_FORMAT, true)
  const checkOutMoment = moment(checkOut, ISO_DATE_FORMAT, true)

  if (!checkInMoment.isValid() || !checkOutMoment.isValid() || !checkOutMoment.isAfter(checkInMoment, 'day')) {
    return filters
  }

  return {
    ...filters,
    checkIn,
    checkOut,
  }
}
